<template>
  <router-view
    class="nonsc page"
  />
</template>

<script>

export default {
  mounted () {
    console.log('nonsc-layout')
  }
}

</script>

<style lang="css" scoped src="./nonsc.css"></style>


// WEBPACK FOOTER //
// src/features/nonsc/NonscLayout.vue